import React from 'react';
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";


import { getHistoricalBaseLineHistory } from '../../apis/EnergyEfficient/EfficientApi';
const ImprovementBaselineHistory = () => {
    const auth = useSelector((state) => state.auth);
  
const {data:historyData, error ,isLoading} = useQuery ({
   queryKey: ["get-improvement-baseline-history"],
    queryFn: () => getHistoricalBaseLineHistory(auth?.token), // fix here
    enabled: !!auth?.token,
})

console.log(historyData)
  // const historyData = [
  //   { date: '06/05/2024', baseline: '800.00 kw' },
  //   { date: '12/12/2024', baseline: '900.00 kw' },
  //   { date: '15/01/2025', baseline: '1000.00 kw' },
  //   { date: '27/07/2025', baseline: '1100.00 kw' },
  //   { date: '06/05/2025', baseline: '1200.00 kw' },
  // ];

  return (
    <div className="p-10 max-w-[739px] mx-auto bg-white rounded-lg border h-[440px] mt-20">
        <div className='flex justify-items-center  ml-10'>

      <div className="text-xl font-bold text-gray-800 mb-4">Improvement Baseline History</div>
      <div className='ml-[400px] border px-3 py-1 mb-2 flex'> view
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.16536 5.9987L8.4987 9.33203L11.832 5.9987" stroke="#98A2B3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
        </div>
      
      <div className="overflow-x-auto">
         <div className="bg-[#2C9963] flex text-white p-5 text-center text-[14px]  w-full">
            
              <div className="px-6 py-3 text-left text-xs font-medium ml-52 ">Date</div>
              <div className="px-6 py-3 text-left text-xs font-medium ml-[300px]">Baseline</div>
            
          </div>
        <table className="min-w-full divide-y divide-gray-200">
         
          <tbody className="bg-white divide-y divide-gray-200 text-center">
            {historyData?.data?.data?.data?.map((item, index) => (
              <tr key={index}>
                {/* <td className="px-6 py-10 whitespace-nowrap text-sm text-gray-500">{item.createdAt}</td> */}
                <td className="px-6 py-10 whitespace-nowrap text-sm text-gray-500">
  {new Date(item.createdAt).toLocaleDateString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  })}
</td>

                <td className="px-6 py-10 whitespace-nowrap text-sm text-gray-500">{item.baselineValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ImprovementBaselineHistory;